import { Helmet } from 'react-helmet-async'
import Typography from '@mui/material/Typography'
import Link from '@/components/Link'
import DirectionalIcon from '@components/theme/DirectionalIcon'
import { useTranslator } from '@/hooks/useTranslator'

const WaitingConfirm = () => {
  const { __ } = useTranslator()

  return (
    <>
      <Helmet>
        <title>Account Inactive</title>
      </Helmet>
      <div className='flex flex-col  gap-3 is-full sm:is-auto md:is-full sm:max-is-[400px] md:max-is-[unset] mbs-11 mbe-11 sm:mbs-14 md:mbs-0 md:mbe-0 bs-full md:min-bs-[80dvh] min-bs-[80dvh] md:px-0 px-5'>
        <Typography className='flex' color='primary.main'>
          <Link href='/cms/login' className='flex items-center gap-1.5'>
            <DirectionalIcon
              ltrIconClass='tabler-chevron-left'
              rtlIconClass='tabler-chevron-right'
              className='text-xl'
            />
            <span>{__('Back to login')}</span>
          </Link>
        </Typography>

        <Typography
          variant='h4'
          className='md:text-[40px] text-[36px] leading-[38px] font-bold mt-8 text-[#FF9F43] text-center'
        >
          {__('Account Inactive')}
        </Typography>
        <Typography className='text-[15px] leading-[22px] text-[##2F2B3DB2] text-center'>
          {__('Account Inactive.')}{' '}
          <Link href='https://zalo.me/0989646482'>
            <span className='text-[#3551F2]'>{__('Contact Us')}</span>
          </Link>{' '}
          {__('to resolve this issue.')}
        </Typography>

        <img
          alt='error-404-illustration'
          src='/images/illustrations/auth/inactive.png'
          className='object-cover bs-[400px] md:bs-[450px] lg:bs-[500px] mbs-10 md:mbs-14 lg:mbs-20'
        />

        <div className='mt-auto text-center'>
          <span>{__('© 2025, Made with ❤️ by')}</span> <span className='text-primary'>{__('DOSI GROUP')}</span>
        </div>
      </div>
    </>
  )
}

export default WaitingConfirm
